module.exports = __webpack_public_path__ + "img/tag.b979b34e.svg";